import { useEffect, useState } from "react";

import { adminApi, type OverviewResponse } from "../api";
import { StatusTile } from "../components/StatusTile";

function formatBytes(bytes: number): string {
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB", "PB"];
  const i = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
  return `${(bytes / 1024 ** i).toFixed(1)} ${units[i]}`;
}

export function Overview(): JSX.Element {
  const [data, setData] = useState<OverviewResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    adminApi
      .get<OverviewResponse>("/api/v1/admin/overview")
      .then(setData)
      .catch((err) => setError(err instanceof Error ? err.message : String(err)));
  }, []);

  return (
    <div>
      <h2 className="page-title">🏠 Overview</h2>
      <p className="page-subtitle">
        KPIs + per-subsystem status — every 🟢/🟡/🔴 below is computed from real signals, never
        rolled into a single security score (भाग E4).
      </p>
      {error && <div className="error-banner">{error}</div>}
      {data && (
        <>
          <div className="kpi-row">
            <div className="kpi">
              <div className="value">{data.project_count}</div>
              <div className="label">Projects</div>
            </div>
            <div className="kpi">
              <div className="value">{data.user_count}</div>
              <div className="label">Users</div>
            </div>
            <div className="kpi">
              <div className="value">{data.object_count}</div>
              <div className="label">Objects</div>
            </div>
            <div className="kpi">
              <div className="value">{data.active_api_key_count}</div>
              <div className="label">Active API Keys</div>
            </div>
            <div className="kpi">
              <div className="value">{formatBytes(data.total_bytes_stored)}</div>
              <div className="label">Stored</div>
            </div>
          </div>
          <div className="status-grid">
            {data.subsystems.map((s) => (
              <StatusTile key={s.name} status={s} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
